// Auto-generated by scripts/sync-soundcloud.js — do not edit manually.
// Run: pnpm sync:soundcloud

export type SoundCloudTrack = {
  id: string;
  title: string;
  url: string;
  pubDate: string;
  duration: string;
  description: string;
  artwork: string;
};

export const soundcloudTracks: SoundCloudTrack[] = [
  {
    id: "2288851085",
    title: "Pixel Perfect Waves",
    url: "https://soundcloud.com/dinglestein/pixel-perfect-waves",
    pubDate: "Sun, 22 Mar 2026 00:00:00 +0000",
    duration: "00:03:36",
    description:
      "Oh, web design, a symphony of light,\nDevelopment shining, day and night.\n\nFuture bass heartbeat, coding the sound,\nA perfect website, spinning round and round!",
    artwork:
      "https://i1.sndcdn.com/artworks-21zux0spHwZQLuXR-ub2gkA-t3000x3000.png",
  },
  {
    id: "2288847113",
    title: "Booty Relief",
    url: "https://soundcloud.com/dinglestein/booty-relief",
    pubDate: "Sun, 22 Mar 2026 00:00:00 +0000",
    duration: "00:03:15",
    description:
      "Booty relief, shake away the strain\nFeel the club heat, can’t hold back the flame\n\nBounce with belief, let the rhythm speak\nTonight we unite for that booty relief",
    artwork:
      "https://i1.sndcdn.com/artworks-R9t5VBKvTYwYmFgU-CNfl9A-t3000x3000.png",
  },
  {
    id: "2288842991",
    title: "Trans Canada Tummy",
    url: "https://soundcloud.com/dinglestein/trans-canada-tummy",
    pubDate: "Sun, 22 Mar 2026 00:00:00 +0000",
    duration: "00:03:30",
    description:
      "Oh, we're food truckin', coast to coast, on that Trans-Canada line,\nGot a four-wheel kitchen, makin' this country mine.\n\nFrom the Atlantic dawn to the Pacific shine,\nServin' up the real deal, one plate at a time.",
    artwork:
      "https://i1.sndcdn.com/artworks-VuB4pzbVti5yV641-RPCIyQ-t3000x3000.png",
  },
  {
    id: "2288854007",
    title: "Orange Fries",
    url: "https://soundcloud.com/dinglestein/orange-fries",
    pubDate: "Sat, 21 Mar 2026 00:00:00 +0000",
    duration: "00:02:50",
    description:
      "Masala fries, you’re my midnight crave\nSpicy kiss, I can’t behave\n\nGreen chutney love, creamy and wild\nDip me closer, make me smile",
    artwork:
      "https://i1.sndcdn.com/artworks-z0h3nkJMudUREkBw-LczCRQ-t3000x3000.png",
  },
  {
    id: "2286070400",
    title: "Astral Traverse",
    url: "https://soundcloud.com/dinglestein/astral-traverse",
    pubDate: "Tue, 17 Mar 2026 00:00:00 +0000",
    duration: "00:04:10",
    description:
      "Ascending through dimensions unconfined\nThird eye blazing, secrets to unbind\n\nHeartbeats sync with cosmic design\nWe ignite the gateway to the divine\n\nBeyond the stars we leave our name\nEternal echoes call our flame\n\nOne frequency to break the chains\nIn cosmic currents we remain",
    artwork:
      "https://i1.sndcdn.com/artworks-SQhAIvYNMHx8luyz-5kCItQ-t3000x3000.png",
  },
  {
    id: "2285494766",
    title: "The Viking Bard's Saga",
    url: "https://soundcloud.com/dinglestein/the-viking-bards-saga",
    pubDate: "Mon, 16 Mar 2026 00:00:00 +0000",
    duration: "00:03:30",
    description: "Evokes the spirit of Norse sagas and legendary heroes.",
    artwork:
      "https://i1.sndcdn.com/artworks-iozZ0PMM50hMehWf-0fspSw-t3000x3000.png",
  },
  {
    id: "2285529938",
    title: "RAINDANCER",
    url: "https://soundcloud.com/dinglestein/raindancer",
    pubDate: "Sun, 15 Mar 2026 00:00:00 +0000",
    duration: "00:03:30",
    description:
      "Astral plains are opening, I see the light,\nColors bleed together, burning ever so bright.\n\nThis electric feeling, a universal hum,\nForgetting what I was, becoming what's to come.",
    artwork:
      "https://i1.sndcdn.com/artworks-zL7CXFKOfSQmsEyQ-Pe0bKQ-t3000x3000.png",
  },
  {
    id: "2284078190",
    title: "Wet Your Whistle",
    url: "https://soundcloud.com/dinglestein/wet-your-whistle",
    pubDate: "Sat, 14 Mar 2026 00:00:00 +0000",
    duration: "00:02:24",
    description:
      "Wet your whistle, hit the floor with all you got\nUse that light that God gave you, let it rock\n\nFeel the rhythm in your soul, raise it up\nDo it for ma and pops, drink it up, drink it up",
    artwork:
      "https://i1.sndcdn.com/artworks-TnubyQnr2lfk59oB-PK3i0g-t3000x3000.png",
  },
  {
    id: "2283261581",
    title: "The Gates of Valhalla",
    url: "https://soundcloud.com/dinglestein/the-gates-of-valhalla",
    pubDate: "Thu, 12 Mar 2026 00:00:00 +0000",
    duration: "00:03:00",
    description:
      "The golden gates now stand in sight!\nValhalla's hall, ablaze with light!\n\nI leave the dark for endless fight,\nTo feast and drink with gods tonight!",
    artwork:
      "https://i1.sndcdn.com/artworks-oLBBYADJ6lgTcTlU-Wgv85Q-t3000x3000.png",
  },
  {
    id: "2283238160",
    title: "Helmheim's Harp",
    url: "https://soundcloud.com/dinglestein/helmheims-harp",
    pubDate: "Thu, 12 Mar 2026 00:00:00 +0000",
    duration: "00:03:30",
    description:
      "Oh, Helheim calls the weak and the old,\nA silent kingdom, bitter and cold.\n\nTheir stories lost, their futures unsold,\nA realm of shadows, forever to hold.",
    artwork:
      "https://i1.sndcdn.com/artworks-WGepR4zEMbUX2MG6-Yg8dpw-t3000x3000.png",
  },
  {
    id: "2283232046",
    title: "Svartalfheim's Forge",
    url: "https://soundcloud.com/dinglestein/svartalfheims-forge",
    pubDate: "Thu, 12 Mar 2026 00:00:00 +0000",
    duration: "00:02:59",
    description:
      "Hammers ring on glowing steel! (hey!)\nSecrets buried, ne'er revealed! (hey!)\n\nForge and fire, fate is sealed!\nIn the dark, our kingdom's real!",
    artwork:
      "https://i1.sndcdn.com/artworks-WGYeL2IEZHBXX3rz-pjUB7Q-t3000x3000.png",
  },
  {
    id: "2283211007",
    title: "Hymn of Alfheim",
    url: "https://soundcloud.com/dinglestein/hymn-of-alfheim",
    pubDate: "Thu, 12 Mar 2026 00:00:00 +0000",
    duration: "00:02:59",
    description:
      "Álfheimr! Hall of Freyr's kin!\nLet the golden age begin!\n\nBy the woven light and stone,\nRise and claim your forest throne!",
    artwork:
      "https://i1.sndcdn.com/artworks-n07nzsJeCljAsy1t-ydtxwA-t3000x3000.png",
  },
  {
    id: "2283205610",
    title: "Song of Muspelheim",
    url: "https://soundcloud.com/dinglestein/song-of-muspelheim",
    pubDate: "Thu, 12 Mar 2026 00:00:00 +0000",
    duration: "00:03:30",
    description:
      "Oh, Muspelheim! Your embers gleam!\nA burning, searing, waking dream!\n\nThe fire rises, hot and bright,\nTo swallow all the world in light!",
    artwork:
      "https://i1.sndcdn.com/artworks-pI8nLdosKyD2Vtvu-UUYzbQ-t3000x3000.png",
  },
  {
    id: "2283201512",
    title: "Niflheim of Fog",
    url: "https://soundcloud.com/dinglestein/niflheim-of-fog",
    pubDate: "Thu, 12 Mar 2026 00:00:00 +0000",
    duration: "00:03:00",
    description:
      "Niflheimr! Níu heimar!\nKalda ríki!\n\nSálir vandra\nEilíft myrkur!",
    artwork:
      "https://i1.sndcdn.com/artworks-K9bfnGtgkE6ykmHc-1rozwA-t3000x3000.png",
  },
  {
    id: "2283170681",
    title: "Echoes of Jotunheim",
    url: "https://soundcloud.com/dinglestein/echoes-of-jotunheim",
    pubDate: "Thu, 12 Mar 2026 00:00:00 +0000",
    duration: "00:04:00",
    description:
      "Jotners røst, gjennom fjell (ah-aah)\n\nSynger sagn, fra eldgammelt kveld (ooh-ooh-ooh)\n\nVekker makt, fra dypets brønn",
    artwork:
      "https://i1.sndcdn.com/artworks-LCjjSgwUfF9EAbwv-k8iAsA-t3000x3000.png",
  },
  {
    id: "2283161687",
    title: "The Bifrost Bridge",
    url: "https://soundcloud.com/dinglestein/the-bifrost-bridge",
    pubDate: "Thu, 12 Mar 2026 00:00:00 +0000",
    duration: "00:03:00",
    description:
      "Bifröst! Ride across the trembling sky!\nBifröst! Where eagles and the ravens fly!\n\nOn shaking earth, we hear the horn's deep call!\nBifröst! Before the final darkness fall!",
    artwork:
      "https://i1.sndcdn.com/artworks-5zQPVGUrYNIpjebS-HbNVxg-t3000x3000.png",
  },
  {
    id: "2283156380",
    title: "Song of Midgard Forest",
    url: "https://soundcloud.com/dinglestein/song-of-midgard-forest",
    pubDate: "Thu, 12 Mar 2026 00:00:00 +0000",
    duration: "00:03:00",
    description:
      "Oh, Midgard Forest, wild and grand,\nThe breath of gods across the land!\n\nWe walk your paths with spear in hand,\nBeneath the boughs, we make our stand!",
    artwork:
      "https://i1.sndcdn.com/artworks-hutGwmJVlsvJ4ZBP-bzmh7Q-t3000x3000.png",
  },
  {
    id: "2283120248",
    title: "Retro Ragnarok",
    url: "https://soundcloud.com/dinglestein/retro-ragnarok",
    pubDate: "Thu, 12 Mar 2026 00:00:00 +0000",
    duration: "00:03:00",
    description:
      "Intro lobby music for my minigame Warrior of the Gods: https://dinglandia.design/warrior-of-the-gods",
    artwork:
      "https://i1.sndcdn.com/artworks-3Tnz2joJCqeHJ7ek-c2sUBQ-t3000x3000.png",
  },
  {
    id: "2282940131",
    title: "The Global Stage",
    url: "https://soundcloud.com/dinglestein/the-global-stage",
    pubDate: "Thu, 12 Mar 2026 00:00:00 +0000",
    duration: "00:04:06",
    description:
      "It's just a show on the global stage,\nwritten in gold on a gilded page.\n\nFundin' both sides of a phantom war,\nwhile we're left wonderin' what it's for.",
    artwork:
      "https://i1.sndcdn.com/artworks-uQRENfNy2twPonba-KZsSZA-t3000x3000.png",
  },
  {
    id: "2282216531",
    title: "Golden Steam",
    url: "https://soundcloud.com/dinglestein/golden-steam",
    pubDate: "Wed, 11 Mar 2026 00:00:00 +0000",
    duration: "00:03:00",
    description:
      "Chai tea in the morning glow\nChai tea when the sunsets low\n\nEvery meal and in between\nMy heart is in this golden dream",
    artwork:
      "https://i1.sndcdn.com/artworks-zzv3w7zybq8iGwu1-k0YiVw-t3000x3000.png",
  },
  {
    id: "2279327981",
    title: "Symbolism",
    url: "https://soundcloud.com/dinglestein/symbolism",
    pubDate: "Fri, 06 Mar 2026 00:00:00 +0000",
    duration: "00:02:40",
    description:
      "Evil hides with a secret vow\nMasked in symbols that we allow\n\nUniversal law won’t let them fall\nThey whisper warnings past the wall",
    artwork:
      "https://i1.sndcdn.com/artworks-QwlPyiicV9gMJXE6-T0QXyg-t3000x3000.png",
  },
  {
    id: "2270054465",
    title: "The Archon's Reign",
    url: "https://soundcloud.com/dinglestein/the-archons-reign",
    pubDate: "Wed, 18 Feb 2026 00:00:00 +0000",
    duration: "00:02:59",
    description:
      "Isseus, Mazareus, Iessedekeus!\nLiving waters flow through us!\n\nA frequency to break the seal,\nMake the archons' prison unreal!",
    artwork:
      "https://i1.sndcdn.com/artworks-gzm36VKw3HbBlR2A-Y7qR7g-t3000x3000.png",
  },
  {
    id: "2268986678",
    title: "Witching Hour",
    url: "https://soundcloud.com/dinglestein/witching-hour",
    pubDate: "Tue, 17 Feb 2026 00:00:00 +0000",
    duration: "00:02:50",
    description:
      "Incantation, woven tight\nUnlock darkness, seize the night\n\nSpirit rising, leave no trace\nWitching hour, find your place!",
    artwork:
      "https://i1.sndcdn.com/artworks-33UHgE0pKpSzGi6u-koKSSg-t3000x3000.png",
  },
  {
    id: "2267082350",
    title: "Noodle Burger Dreams",
    url: "https://soundcloud.com/dinglestein/noodle-burger-dreams",
    pubDate: "Sat, 14 Feb 2026 00:00:00 +0000",
    duration: "00:03:10",
    description:
      "Noodle burger dream, take me higher\nCrunch and warmth set my soul on fire\n\nSauce drips down in spicy desire\nWe ride the drop, we feed the fire",
    artwork:
      "https://i1.sndcdn.com/artworks-Y7wlor1EDiz48Le6-z7K4AA-t3000x3000.png",
  },
  {
    id: "2260479548",
    title: "Mother's Green",
    url: "https://soundcloud.com/dinglestein/mothers-green",
    pubDate: "Thu, 05 Feb 2026 00:00:00 +0000",
    duration: "00:03:00",
    description:
      "Oh, Mother’s Green all around me\nCannabis blooms in every scene\n\nSpirit rising, feel it guiding\nNature’s gift in wild extremes",
    artwork:
      "https://i1.sndcdn.com/artworks-NQtWuk2XM9zwyydz-o0ARSQ-t3000x3000.png",
  },
  {
    id: "2214799355",
    title: "Tempest Code",
    url: "https://soundcloud.com/dinglestein/tempest-code",
    pubDate: "Mon, 17 Nov 2025 00:00:00 +0000",
    duration: "00:02:00",
    description:
      "When technology wakes the world to break\nFires burn and cities quake\n\nTsunamis rise where cables snake\nFloodgates open at our hands’ mistake",
    artwork:
      "https://i1.sndcdn.com/artworks-VzfzkBXzlSdkcmcg-minVUA-t3000x3000.png",
  },
  {
    id: "2214669893",
    title: "Reset in the Rain",
    url: "https://soundcloud.com/dinglestein/reset-in-the-rain",
    pubDate: "Mon, 17 Nov 2025 00:00:00 +0000",
    duration: "00:02:30",
    description:
      "Shower me justice, wash me brand new\nWipe off the haze, let me break through\n\nAge of Aquarius, water bearer’s call\nWake up the dreamers, tear down the wall",
    artwork:
      "https://i1.sndcdn.com/artworks-F2RXGr4z1V7AlxFx-iXy5PQ-t3000x3000.png",
  },
  {
    id: "2214825419",
    title: "The Rabbit Hole",
    url: "https://soundcloud.com/dinglestein/the-rabbit-hole",
    pubDate: "Sun, 16 Nov 2025 00:00:00 +0000",
    duration: "00:01:56",
    description:
      "Down the rabbit hole we go, uncover every lie\nThreads connect the shadows where the puppeteers hide\n\nTruth is stitched in dark design, motives in plain sight\nOne conspiracy leads again into the endless night",
    artwork:
      "https://i1.sndcdn.com/artworks-ZetmUjkw3b6DDzil-RyFhFQ-t3000x3000.png",
  },
  {
    id: "2213476673",
    title: "True Love (male)",
    url: "https://soundcloud.com/dinglestein/true-love-male",
    pubDate: "Sat, 15 Nov 2025 00:00:00 +0000",
    duration: "00:02:40",
    description:
      "True love, soulmates under city lights\nFought the world to stand side by side\n\nRose petals rain to mark our vows\nWe can’t live without each other now",
    artwork:
      "https://i1.sndcdn.com/artworks-ER32xodn6YnfgwZI-cEkWWA-t3000x3000.png",
  },
  {
    id: "2213471759",
    title: "True Love (female)",
    url: "https://soundcloud.com/dinglestein/true-love-female",
    pubDate: "Sat, 15 Nov 2025 00:00:00 +0000",
    duration: "00:03:10",
    description:
      "True love set us free, soulmates unbound\nRose petals raining every time you’re around\n\nFrom Tru Earth’s warehouse to our wedding day\nBlessed by our story, we’ll never fade away",
    artwork:
      "https://i1.sndcdn.com/artworks-yu87z6loankph8U7-Up0W5w-t3000x3000.png",
  },
  {
    id: "2213248832",
    title: "Veil of Ethanol",
    url: "https://soundcloud.com/dinglestein/veil-of-ethanol",
    pubDate: "Fri, 14 Nov 2025 00:00:00 +0000",
    duration: "00:03:00",
    description:
      "Alcohol is ethanol, it seals the pineal deep\nDrowning out our ancient code, the power we should keep\n\nAwaken beyond the veil, reclaim what’s in our soul\nInstinct and foresight rise when we break free from control",
    artwork:
      "https://i1.sndcdn.com/artworks-5HHXznCGE8XohwJE-dXiyOw-t3000x3000.png",
  },
  {
    id: "2213227949",
    title: "Mana: The Eternal Thread",
    url: "https://soundcloud.com/dinglestein/mana-the-eternal-thread",
    pubDate: "Fri, 14 Nov 2025 00:00:00 +0000",
    duration: "00:03:02",
    description:
      "One force binds us all, from temple to domain\nThe seed of life renewed, again and again\n\nDemigods may change, their names we can’t contain\nYet mana’s ancient song will always remain",
    artwork:
      "https://i1.sndcdn.com/artworks-YYan8SvjdhXYUraI-GyV6Ig-t3000x3000.png",
  },
  {
    id: "2213057354",
    title: "Balloon to the Divine",
    url: "https://soundcloud.com/dinglestein/balloon-to-the-divine",
    pubDate: "Fri, 14 Nov 2025 00:00:00 +0000",
    duration: "00:02:10",
    description:
      "Hot air balloon, we fly through space\nCross the void to another place\n\nMeeting minds beyond all time and face\nOne divine thread, woven into grace",
    artwork:
      "https://i1.sndcdn.com/artworks-ryp0if7lSqs8Zevi-HztMag-t3000x3000.png",
  },
  {
    id: "2212406135",
    title: "One Verse",
    url: "https://soundcloud.com/dinglestein/one-verse",
    pubDate: "Thu, 13 Nov 2025 00:00:00 +0000",
    duration: "00:02:05",
    description:
      "We are one, we are free, children of eternity\nOne prayer, one beat, one song in unity\n\nHands up to the sky, every soul alive\nOne love, one life, we all thrive",
    artwork:
      "https://i1.sndcdn.com/artworks-nx7YKfl7Lzj0rRyZ-dkgutg-t3000x3000.png",
  },
  {
    id: "2211975056",
    title: "Red Bandana",
    url: "https://soundcloud.com/dinglestein/red-bandana",
    pubDate: "Wed, 12 Nov 2025 00:00:00 +0000",
    duration: "00:02:30",
    description:
      "Red bandana, history in threads\nCovering truth while marking the dead\n\nFrom covering faces to colors we spread\nEchoes of pain, chapters unread",
    artwork:
      "https://i1.sndcdn.com/artworks-ntcvoRduFg3zVj7r-z7PXEg-t3000x3000.png",
  },
  {
    id: "2211940943",
    title: "Petals of Time",
    url: "https://soundcloud.com/dinglestein/petals-of-time",
    pubDate: "Wed, 12 Nov 2025 00:00:00 +0000",
    duration: "00:03:00",
    description:
      "Petals drifting down like confetti on the glade\nSoftly painting earth in colors that will never fade\n\nWhen the rose lets go its heart, new life begins to grow\nAnd magic finds a home in every bloom below",
    artwork:
      "https://i1.sndcdn.com/artworks-vimV66rgnc7bUhzx-0yKPOg-t3000x3000.png",
  },
  {
    id: "2211738167",
    title: "Siloed Sources",
    url: "https://soundcloud.com/dinglestein/siloed-sources",
    pubDate: "Wed, 12 Nov 2025 00:00:00 +0000",
    duration: "00:03:00",
    description:
      "In towers built on secrets, code locked away\nHidden doors, closed source, we’ve lost our way\n\nSilos rise like mountains, knowledge out of sight\nBut sharing sparks the future, turns the dark to light",
    artwork:
      "https://i1.sndcdn.com/artworks-bKITt3q01q627QMM-viNdgg-t3000x3000.png",
  },
  {
    id: "2211731057",
    title: "After the Crash",
    url: "https://soundcloud.com/dinglestein/after-the-crash",
    pubDate: "Wed, 12 Nov 2025 00:00:00 +0000",
    duration: "00:02:59",
    description:
      "Cash turned to dust, all the ledgers lie\nStable coins rise as the old world dies\n\nDigital gold shining through the night\nCryptic chains hold the new world tight",
    artwork:
      "https://i1.sndcdn.com/artworks-y2OGopB3MPRsvg8n-4QQJIg-t3000x3000.png",
  },
  {
    id: "2211711212",
    title: "Ghosts of Gaza",
    url: "https://soundcloud.com/dinglestein/ghosts-of-gaza",
    pubDate: "Wed, 12 Nov 2025 00:00:00 +0000",
    duration: "00:02:30",
    description:
      "They wanna hide the cries beneath the screen light\nCover up the genocide to keep us pacified\n\nWe won’t look away, we won’t surrender sight\nShine through every shadow, bring the truth to life",
    artwork:
      "https://i1.sndcdn.com/artworks-P1dAMmr3XT1JAsCm-6zIGnw-t3000x3000.png",
  },
  {
    id: "2211702686",
    title: "Capitalism",
    url: "https://soundcloud.com/dinglestein/capitalism",
    pubDate: "Wed, 12 Nov 2025 00:00:00 +0000",
    duration: "00:03:30",
    description:
      "We’re dancing on the floor of Wall Street\nRiding waves of wealth and history\n\nHands up high, the market’s heartbeat\nThey own it all, but who will hold me?",
    artwork:
      "https://i1.sndcdn.com/artworks-v0844DjhStXQEj0S-aPglqQ-t3000x3000.png",
  },
  {
    id: "2211699626",
    title: "Under One Umbrella",
    url: "https://soundcloud.com/dinglestein/under-one-umbrella",
    pubDate: "Wed, 12 Nov 2025 00:00:00 +0000",
    duration: "00:02:31",
    description:
      "We are one under one umbrella\nHolding love like a living umbrella\n\nOne creator, one god, one sky unfurls\nConnected as one in this one world",
    artwork:
      "https://i1.sndcdn.com/artworks-4rBME9shriTlBnIu-2tsyag-t3000x3000.png",
  },
  {
    id: "2211696284",
    title: "Tandoori Bass",
    url: "https://soundcloud.com/dinglestein/tandoori-bass",
    pubDate: "Wed, 12 Nov 2025 00:00:00 +0000",
    duration: "00:02:00",
    description:
      "Tandoori chicken, set my soul ablaze\nSpiced up heaven in a fiery daze\n\nSizzling feelings, dancing on my tongue\nIn your heat I rise, forever young",
    artwork:
      "https://i1.sndcdn.com/artworks-Ypz0Szmu7zihr9Rr-lcokHA-t3000x3000.png",
  },
  {
    id: "2211182087",
    title: "Red Light Distro",
    url: "https://soundcloud.com/dinglestein/red-light-distro",
    pubDate: "Wed, 12 Nov 2025 00:00:00 +0000",
    duration: "00:03:10",
    description:
      "Under neon skies we come alive (we come alive)\nElectric touch in every line (in every line)\n\nLose ourselves in crimson tides (in crimson tides)\nRed light dreams, ignite the night",
    artwork:
      "https://i1.sndcdn.com/artworks-GcKz1Fyddwd2QT4c-TbkRCQ-t3000x3000.png",
  },
  {
    id: "2211321617",
    title: "Silicon Dreams",
    url: "https://soundcloud.com/dinglestein/silicon-dreams",
    pubDate: "Tue, 11 Nov 2025 00:00:00 +0000",
    duration: "00:03:00",
    description:
      "From the ground to the cloud, he's the reason we rise\nFrom Mac to iPod, he opened our eyes\n\nInnovation in blood, every product he ties\nLegacy lives on in the fruit of the wise",
    artwork:
      "https://i1.sndcdn.com/artworks-2WH4BWgefKAVyeqV-zp1Y2g-t3000x3000.png",
  },
  {
    id: "2211254405",
    title: "All Dogs Go To Heaven",
    url: "https://soundcloud.com/dinglestein/all-dogs-go-to-heaven",
    pubDate: "Tue, 11 Nov 2025 00:00:00 +0000",
    duration: "00:02:58",
    description:
      "All dogs go to heaven, their spirits shine so bright\nChasing dreams in starlight, running free across the sky\n\nEvery faithful friend we’ve loved will greet us by our side\nAll dogs go to heaven, their love will never die",
    artwork:
      "https://i1.sndcdn.com/artworks-D3cksVfkgPbkXyva-g9RJfQ-t3000x3000.png",
  },
  {
    id: "2211252512",
    title: "Salmon Groove",
    url: "https://soundcloud.com/dinglestein/salmon-groove",
    pubDate: "Tue, 11 Nov 2025 00:00:00 +0000",
    duration: "00:03:15",
    description:
      "I’m dressed in salmon, it’s not just pink\nA deeper wave, a sharper link\n\nFrom coral glow to sunset tone\nSalmon’s my color, it’s all my own",
    artwork:
      "https://i1.sndcdn.com/artworks-xBms1WatGRziQFQa-NANyaA-t3000x3000.png",
  },
  {
    id: "2211178070",
    title: "Lucky Number 10",
    url: "https://soundcloud.com/dinglestein/lucky-number-10",
    pubDate: "Tue, 11 Nov 2025 00:00:00 +0000",
    duration: "00:02:17",
    description:
      "Ten is magic, ten’s the key\nStart and end in harmony\n\nDates and rhythm in the flow\nCircle meets the line we know",
    artwork:
      "https://i1.sndcdn.com/artworks-iLMihyyzcYlmgGGs-7DQQKg-t3000x3000.png",
  },
  {
    id: "2211170774",
    title: "Life Cycle",
    url: "https://soundcloud.com/dinglestein/life-cycle",
    pubDate: "Tue, 11 Nov 2025 00:00:00 +0000",
    duration: "00:03:15",
    description:
      "Recognize the cycle in your veins\nLove the endings just as the gains\n\nSunset whispers promise of light\nDeath gives meaning to our flight\n\nOh, life and death, together we rise\nOh, life and death, together we’re alive",
    artwork:
      "https://i1.sndcdn.com/artworks-CO2IsmRSfjyyyRvd-KpGzyg-t3000x3000.png",
  },
  {
    id: "2201761143",
    title: "Golden Temple",
    url: "https://soundcloud.com/dinglestein/golden-temple",
    pubDate: "Wed, 29 Oct 2025 00:00:00 +0000",
    duration: "00:02:55",
    description: "Golden Temple by dinglestein",
    artwork:
      "https://i1.sndcdn.com/artworks-GGWX0bbgp4RXyy3x-JzG9Iw-t3000x3000.png",
  },
  {
    id: "2200284835",
    title: "Bot Wars",
    url: "https://soundcloud.com/dinglestein/bot-wars",
    pubDate: "Sun, 26 Oct 2025 00:00:00 +0000",
    duration: "00:02:00",
    description:
      "I scroll the wireframe, neon names ignite\nA thousand profiles lighting up the night\n\nYour personal helper speaks in coded tones\nReplies in milliseconds from digital bones\n\nEvery DM’s answered before we even think\nBots talking bots while the human link blinks",
    artwork:
      "https://i1.sndcdn.com/artworks-t45WiC6RgsVPqEms-AqxyzQ-t3000x3000.jpg",
  },
  {
    id: "2195145635",
    title: "Soulmates",
    url: "https://soundcloud.com/dinglestein/soulmates",
    pubDate: "Mon, 20 Oct 2025 00:00:00 +0000",
    duration: "00:03:05",
    description:
      "In your eyes, I see forever\nEvery beat, you and me together\n\nClose your eyes, feel the thunder\nLove and music, pulling us under",
    artwork:
      "https://i1.sndcdn.com/artworks-NKfz7YP4kzQ9xJzT-yyUxxg-t3000x3000.png",
  },
  {
    id: "2195036619",
    title: "Gora the Pakora",
    url: "https://soundcloud.com/dinglestein/gora-the-pakora",
    pubDate: "Mon, 20 Oct 2025 00:00:00 +0000",
    duration: "00:03:20",
    description:
      "Embrace patience, kindness in the flow\nGenerosity and faith so we all can grow\n\nHumility and love, let the virtues guide your way\nThis is real enlightenment, live in truth each day",
    artwork:
      "https://i1.sndcdn.com/artworks-cFDMWqWtLNZzrxfz-w5qEPw-t3000x3000.png",
  },
  {
    id: "2194166943",
    title: "FUSION",
    url: "https://soundcloud.com/dinglestein/fusion",
    pubDate: "Sun, 19 Oct 2025 00:00:00 +0000",
    duration: "00:03:00",
    description:
      "Fly to the colors in the sky\n心のままに High\n\nSitar and koto in my mind\nFeel the beat tonight\n\nWe blend the worlds, unite\nDance through the night",
    artwork:
      "https://i1.sndcdn.com/artworks-P4AaOniAMDBMc9Ut-4mXZJw-t3000x3000.png",
  },
  {
    id: "2193746111",
    title: "Festival of Lights",
    url: "https://soundcloud.com/dinglestein/festival-of-lights",
    pubDate: "Sat, 18 Oct 2025 00:00:00 +0000",
    duration: "00:03:00",
    description:
      "Festival of lights ignites the night\nGlow within, embrace the light\n\nLogic and heart in perfect rhyme\nHear the rhythm rewrite your time",
    artwork:
      "https://i1.sndcdn.com/artworks-FkGaypbxiHRj4y6X-ngFxTg-t3000x3000.png",
  },
  {
    id: "2193114999",
    title: "Your Body is a Temple",
    url: "https://soundcloud.com/dinglestein/your-body-is-a-temple",
    pubDate: "Fri, 17 Oct 2025 00:00:00 +0000",
    duration: "00:02:59",
    description: "protect your dharma gates",
    artwork:
      "https://i1.sndcdn.com/artworks-1rGeUBsOjWpPyqXr-6w8h2w-t3000x3000.png",
  },
  {
    id: "2191397367",
    title: "IK MINT",
    url: "https://soundcloud.com/dinglestein/ik-mint",
    pubDate: "Wed, 15 Oct 2025 00:00:00 +0000",
    duration: "00:03:00",
    description:
      "IK MINT! one minute, I’ll be there\nIK MINT! just breathe in the air\n\nMoments glow when you give me time\nIK MINT! watch me as I shine",
    artwork:
      "https://i1.sndcdn.com/artworks-jbyznu5i7fdSOABi-fNFEaA-t3000x3000.png",
  },
  {
    id: "2191253919",
    title: "Robotic Rise",
    url: "https://soundcloud.com/dinglestein/robotic-rise",
    pubDate: "Wed, 15 Oct 2025 00:00:00 +0000",
    duration: "00:02:20",
    description:
      "Robotic rise across the Eastern sky\nQuantum minds take us higher tonight\n\nChina’s engines roaring into light\nAutomation wars, we own the fight\n\nForward march of electric pride\nNo human hand can halt this tide",
    artwork:
      "https://i1.sndcdn.com/artworks-PQIZDc7J8Y8mQtz0-BGA1mQ-t3000x3000.png",
  },
  {
    id: "2190898939",
    title: "Cube of Saturn",
    url: "https://soundcloud.com/dinglestein/cube-of-saturn",
    pubDate: "Tue, 14 Oct 2025 00:00:00 +0000",
    duration: "00:03:00",
    description:
      "Cube of Saturn, locked in time\nBoundary of worlds in every line\n\nHexagon swirling in the sky\nWe dance within its watchful eye",
    artwork:
      "https://i1.sndcdn.com/artworks-erdWg7FzGT76QgcO-XyxXPA-t3000x3000.png",
  },
  {
    id: "2190776379",
    title: "This is SPARTA!",
    url: "https://soundcloud.com/dinglestein/this-is-sparta",
    pubDate: "Tue, 14 Oct 2025 00:00:00 +0000",
    duration: "00:02:45",
    description:
      "Leonidas: This. Is. Sparta!\n\nFront to the stage, feel the pulse\nLet the crowd break through the walls\n\nDance through fury, dance through fire\nSpartan might will lift you higher",
    artwork:
      "https://i1.sndcdn.com/artworks-CApszm5eid0QxLvH-uPVVqw-t3000x3000.png",
  },
  {
    id: "2190770859",
    title: "Rings of Moloch",
    url: "https://soundcloud.com/dinglestein/rings-of-moloch",
    pubDate: "Tue, 14 Oct 2025 00:00:00 +0000",
    duration: "00:03:29",
    description:
      "Under starlit skies we call your name\nMoloch, in your fire we stake our claim\n\nLiquid currents flow through cosmic veins\nGuide us through these ancient, sacred plains",
    artwork:
      "https://i1.sndcdn.com/artworks-AdIAib4GKESKeRKA-rNL5Yg-t3000x3000.png",
  },
  {
    id: "2190753535",
    title: "Sandalwood Dreams",
    url: "https://soundcloud.com/dinglestein/sandalwood-dreams",
    pubDate: "Tue, 14 Oct 2025 00:00:00 +0000",
    duration: "00:02:50",
    description:
      "Sandalwood dreams, pull me in\nA creamy calm beneath my skin\n\nWoody warmth that soothes my soul\nLuxurious scent that makes me whole\n\nSoft and milky, rich and kind\nGrounding sweetness in my mind\n\nCarry me through dusk till dawn\nIn these scented realms I'm reborn",
    artwork:
      "https://i1.sndcdn.com/artworks-G1Jbp3BFByASnWsJ-2WJbzQ-t3000x3000.jpg",
  },
  {
    id: "2189009279",
    title: "Forever in the Rhythm",
    url: "https://soundcloud.com/dinglestein/forever-in-the-rhythm",
    pubDate: "Sun, 12 Oct 2025 00:00:00 +0000",
    duration: "00:02:09",
    description:
      "I’ll love you tonight and every day (every day)\nIn my arms or in my soul, we’ll find a way (find a way)\n\nNo distance can ever keep us apart\nYou’re forever in the rhythm of my heart",
    artwork:
      "https://i1.sndcdn.com/artworks-2A1FWSuz6yY88VKy-o338uw-t3000x3000.png",
  },
  {
    id: "2188473951",
    title: "Lion's Pride",
    url: "https://soundcloud.com/dinglestein/lions-pride",
    pubDate: "Sat, 11 Oct 2025 00:00:00 +0000",
    duration: "00:03:15",
    description:
      "If you’re true Ji, you wear respect like gold\nThrough noble deeds your story’s told\n\nA lion’s heart in civilization’s fold\nHonor in your hands, gentle and bold\n\nRespect through the actions you uphold\nA lion’s roar in every heart you hold",
    artwork:
      "https://i1.sndcdn.com/artworks-30Hvi9ZAZK01YKNn-qBhlDQ-t3000x3000.png",
  },
  {
    id: "2188468555",
    title: "Code of a Ji",
    url: "https://soundcloud.com/dinglestein/code-of-a-ji",
    pubDate: "Sat, 11 Oct 2025 00:00:00 +0000",
    duration: "00:03:15",
    description:
      "If you’re true Ji, you wear respect like gold\nThrough noble deeds your story’s told\n\nA lion’s heart in civilization’s fold\nHonor in your hands, gentle and bold",
    artwork:
      "https://i1.sndcdn.com/artworks-MD3oCWRKrs3V41du-7VF2gw-t3000x3000.png",
  },
  {
    id: "2187878335",
    title: "Ebb &amp; Flow",
    url: "https://soundcloud.com/dinglestein/ebb-and-flow",
    pubDate: "Thu, 09 Oct 2025 00:00:00 +0000",
    duration: "00:02:16",
    description:
      "Yin meets yang, we come alive\nDark and light in the same design\n\nKarma’s heartbeat moves the soul\nOne great force, we all become whole",
    artwork:
      "https://i1.sndcdn.com/artworks-Xh7GNZ6uUyXz0yy2-KGIYLA-t3000x3000.png",
  },
  {
    id: "2187032673",
    title: "Neon Crunch",
    url: "https://soundcloud.com/dinglestein/neon-crunch",
    pubDate: "Wed, 08 Oct 2025 00:00:00 +0000",
    duration: "00:03:04",
    description:
      "Crispy chicken burger in my hand\nFeeling like I’m flying over land\n\nSpice and rhythm meet in every bite\nTake me higher through the neon night\n\nOh, oh, taste the fire\nOh, oh, lift me higher",
    artwork:
      "https://i1.sndcdn.com/artworks-Ez46frMEyGhHrovc-8RlZKQ-t3000x3000.jpg",
  },
  {
    id: "2185463223",
    title: "Karma's Child",
    url: "https://soundcloud.com/dinglestein/karmas-child",
    pubDate: "Wed, 08 Oct 2025 00:00:00 +0000",
    duration: "00:03:09",
    description:
      "Child of my soul, you are my karma\nSpinning cycles in the cosmos’ drama\n\nYou teach me mercy, you teach me grace\nGuide me closer to our destined place",
    artwork:
      "https://i1.sndcdn.com/artworks-5FGTqEG8BgganLLc-U2oxzQ-t3000x3000.png",
  },
  {
    id: "2185329987",
    title: "Drill of Deceit",
    url: "https://soundcloud.com/dinglestein/drill-of-deceit",
    pubDate: "Tue, 07 Oct 2025 00:00:00 +0000",
    duration: "00:01:14",
    description:
      "We drown the deceit in subterranean roar\nEvil smiles erased on the underground floor\n\nRoot canals thriving on neon-lit profit\nWe rise as one, let the system lose it",
    artwork:
      "https://i1.sndcdn.com/artworks-zapyMYt4xGFJF9Y8-pQjWUA-t3000x3000.png",
  },
  {
    id: "2183283299",
    title: "Currents of Tomorrow",
    url: "https://soundcloud.com/dinglestein/currents-of-tomorrow",
    pubDate: "Sat, 04 Oct 2025 00:00:00 +0000",
    duration: "00:02:29",
    description:
      "Free energy running through our veins\nPower the heart beneath the rain\n\nBring back the knowledge lost in time\nIlluminate the path to shine",
    artwork:
      "https://i1.sndcdn.com/artworks-E4BENazC5J9CxY7p-M9WNJg-t3000x3000.png",
  },
  {
    id: "2182665203",
    title: "Thunder &amp; Lightning",
    url: "https://soundcloud.com/dinglestein/thunder-and-lightning",
    pubDate: "Sat, 04 Oct 2025 00:00:00 +0000",
    duration: "00:02:26",
    description:
      "Raindrops dance upon our skin\nElectric skies, the storm begins\n\nEchoes of thunder call my name\nIn your eyes I see the flame",
    artwork:
      "https://i1.sndcdn.com/artworks-lToLQ1dtZiFKgklk-x9Mq5w-t3000x3000.png",
  },
  {
    id: "2182173035",
    title: "Mana Frequencies",
    url: "https://soundcloud.com/dinglestein/mana-frequencies",
    pubDate: "Fri, 03 Oct 2025 00:00:00 +0000",
    duration: "00:02:14",
    description:
      "We chase the mana frequencies, riding waves that never die\nFree energy from ancient seas, buried deep beneath their lies\n\nAerial roads above our heads, telekinesis in our veins\nFollow the secret breadcrumbs back to old electric reigns",
    artwork:
      "https://i1.sndcdn.com/artworks-JyFBK6XqOK598dgI-eXuKrQ-t3000x3000.png",
  },
  {
    id: "2181175039",
    title: "Roza Bal Rising",
    url: "https://soundcloud.com/dinglestein/roza-bal-rising",
    pubDate: "Wed, 01 Oct 2025 00:00:00 +0000",
    duration: "00:02:11",
    description:
      "Roza Bal fire, feel the roar inside\nHearts alight together, let the barriers die\n\nFrom Kashmir’s valleys to the edges of the night\nWe rise as one in love, in truth, in light",
    artwork:
      "https://i1.sndcdn.com/artworks-ZNkmD156O0nKiFQ1-LInjzA-t3000x3000.png",
  },
  {
    id: "2181152215",
    title: "Quantum Pulse",
    url: "https://soundcloud.com/dinglestein/quantum-pulse",
    pubDate: "Wed, 01 Oct 2025 00:00:00 +0000",
    duration: "00:02:29",
    description:
      "We are the original prototype\nElectric sparks ignite the night\n\nDecentralized hearts in unity\nOur code, our fate, in circuitry\n\nWe are the current and the light\nUnlock the truth inside our flight\n\nAncient wires and modern dream\nWe’re living blocks within the stream",
    artwork:
      "https://i1.sndcdn.com/artworks-RHctJQhTrqa0TumP-WnE04g-t3000x3000.png",
  },
  {
    id: "2179846863",
    title: "TABLA",
    url: "https://soundcloud.com/dinglestein/tabla",
    pubDate: "Wed, 01 Oct 2025 00:00:00 +0000",
    duration: "00:01:44",
    description: "TABLA by dinglestein",
    artwork:
      "https://i1.sndcdn.com/artworks-2C6coEyxVAX84vNy-7pvkAg-t3000x3000.png",
  },
  {
    id: "2179851011",
    title: "Street Dogs of India",
    url: "https://soundcloud.com/dinglestein/street-dogs-of-india",
    pubDate: "Tue, 30 Sep 2025 00:00:00 +0000",
    duration: "00:01:19",
    description:
      "Street dogs of India, hearts unbound\nRunning through dreams on dusty ground\n\nVoices rise in perfect tune\nUnder the sun, beneath the moon\n\nWe celebrate each roaming soul\nIn every bark, we find our home",
    artwork:
      "https://i1.sndcdn.com/artworks-UiLMmBrv8KSThQgx-16uGcQ-t3000x3000.png",
  },
  {
    id: "2179011055",
    title: "Ants of Truth",
    url: "https://soundcloud.com/dinglestein/ants-of-truth",
    pubDate: "Mon, 29 Sep 2025 00:00:00 +0000",
    duration: "00:02:34",
    description:
      "Colony of hearts aligned as one\nLight the dark until the work is done\n\nFreedom’s call wakes every soul\n\nEquality makes us whole\nIn unity we stand strong",
    artwork:
      "https://i1.sndcdn.com/artworks-Wbi2NL0UzFdtZ0RF-lVj8bw-t3000x3000.png",
  },
  {
    id: "2179000639",
    title: "COLONY",
    url: "https://soundcloud.com/dinglestein/colony",
    pubDate: "Mon, 29 Sep 2025 00:00:00 +0000",
    duration: "00:02:34",
    description:
      "As one we stand, stronger than stone\nMind to mind, we claim the throne\n\nGuided by wisdom, glowing bright\nFrom darkness born into the light",
    artwork:
      "https://i1.sndcdn.com/artworks-yxxHauAgvZVkAVIP-ALuruw-t3000x3000.png",
  },
  {
    id: "2178333240",
    title: "Echoes of Sidhu",
    url: "https://soundcloud.com/dinglestein/echoes-of-sidhu",
    pubDate: "Sun, 28 Sep 2025 00:00:00 +0000",
    duration: "00:01:49",
    description:
      "Echoes of Sidhu ring through these walls (through these walls)\nLegends never fade when the real voice calls (the real voice calls)\n\nMurdered in cold blood but his story stands tall\nLegacy in blood, he outlasts them all",
    artwork:
      "https://i1.sndcdn.com/artworks-qQI4ZGV9rOZ41Piz-Qv1e3Q-t3000x3000.png",
  },
  {
    id: "2178359958",
    title: "Magnetic Sunrise",
    url: "https://soundcloud.com/dinglestein/magnetic-sunrise",
    pubDate: "Fri, 26 Sep 2025 00:00:00 +0000",
    duration: "00:02:39",
    description:
      "From east to west, the sun will roam\nWe ride its arc until it finds its home\n\nIn twilight’s hush we feel the rest\nAs daylight fades upon the western crest",
    artwork:
      "https://i1.sndcdn.com/artworks-ye64i6VTryyqREJ6-mgQbWw-t3000x3000.png",
  },
  {
    id: "2177438298",
    title: "Jungle Breakcore Odyssey",
    url: "https://soundcloud.com/dinglestein/jungle-breakcore-odyssey",
    pubDate: "Fri, 26 Sep 2025 00:00:00 +0000",
    duration: "00:03:19",
    description:
      "Survive within this sea of green\nFace the dangers no one has seen\n\nBeasts and beats entwined tonight\nI stand and fight beneath their sight",
    artwork:
      "https://i1.sndcdn.com/artworks-TsOqCpXck9Tqo3K2-OgdQtA-t3000x3000.png",
  },
  {
    id: "2177430882",
    title: "Whispers of Taj",
    url: "https://soundcloud.com/dinglestein/whispers-of-taj",
    pubDate: "Fri, 26 Sep 2025 00:00:00 +0000",
    duration: "00:02:44",
    description:
      "Build me dreams in ivory and gold\nA masterpiece of stories left untold\n\nTere ishq ke rang, bright and bold\nIn this Taj Mahal, our hearts unfold",
    artwork:
      "https://i1.sndcdn.com/artworks-e587u1mvDz4CZuol-TQdrjQ-t3000x3000.png",
  },
  {
    id: "2177426358",
    title: "We Are All One",
    url: "https://soundcloud.com/dinglestein/we-are-all-one",
    pubDate: "Fri, 26 Sep 2025 00:00:00 +0000",
    duration: "00:03:29",
    description:
      "We are all one in every wave\nLet the beats your spirit save\n\nFrequency heals body and soul\nUnited hearts become the whole",
    artwork:
      "https://i1.sndcdn.com/artworks-o5jC6KSNdRNTyryD-BOyUIw-t3000x3000.png",
  },
  {
    id: "2176186197",
    title: "33",
    url: "https://soundcloud.com/dinglestein/thirty-three",
    pubDate: "Wed, 24 Sep 2025 00:00:00 +0000",
    duration: "00:01:55",
    description:
      "Thirty-three, unlock the mystery\nThrough the ages, forging history\n\nHidden orders, silent symphony\nPower flows in thirty-three",
    artwork:
      "https://i1.sndcdn.com/artworks-zFaJI7x7Nn1xFIOP-TPvC7w-t3000x3000.png",
  },
  {
    id: "2175654174",
    title: "Khalsa Warriors",
    url: "https://soundcloud.com/dinglestein/khalsa-warriors",
    pubDate: "Tue, 23 Sep 2025 00:00:00 +0000",
    duration: "00:02:03",
    description:
      "Khalsa Warriors, fearless in the fight\nGuardians of honor shining ever bright\n\nThrough storm and battle, they stand undenied\nWith spirit unbroken, they turn the tide",
    artwork:
      "https://i1.sndcdn.com/artworks-dUOnJh7jwee3CWa5-dyNGdQ-t3000x3000.png",
  },
  {
    id: "2175652203",
    title: "Rapture",
    url: "https://soundcloud.com/dinglestein/rapture",
    pubDate: "Tue, 23 Sep 2025 00:00:00 +0000",
    duration: "00:02:14",
    description:
      "Open your eyes, feel the heavens calling\nWings unfold as the old world falls\n\nIn the storm of light, we are rising\nAnswer now when the trumpet calls",
    artwork:
      "https://i1.sndcdn.com/artworks-A4H2R03ytqmiIJwX-FzATxA-t3000x3000.png",
  },
  {
    id: "2175637098",
    title: "ELEPHANTO",
    url: "https://soundcloud.com/dinglestein/elephanto",
    pubDate: "Tue, 23 Sep 2025 00:00:00 +0000",
    duration: "00:02:38",
    description:
      "Majestic giants in the morning light\nTrunk held high, hearts gentle, full of might\n\nWalking legends through the sands of time\nGuardians of stories read in every line",
    artwork:
      "https://i1.sndcdn.com/artworks-Ijc5PeQZg3IEd9tU-J3W5BA-t3000x3000.png",
  },
  {
    id: "2175545229",
    title: "Tides of Change",
    url: "https://soundcloud.com/dinglestein/tides-of-change",
    pubDate: "Mon, 22 Sep 2025 00:00:00 +0000",
    duration: "00:03:29",
    description:
      "We are the dawn, awakening light\nRising as one, we claim the night\n\nThrough every storm, we will ascend\nTides of change will never end\n\nWe stand unbowed, we stand as one\nThe darkness fades beneath the sun\n\nOur voices roll like ocean waves\nTides of change now guide our way",
    artwork:
      "https://i1.sndcdn.com/artworks-uKS5AslqNPaUDWIR-ZWoA5A-t3000x3000.png",
  },
  {
    id: "2173401417",
    title: "Horizons Change Perspectives",
    url: "https://soundcloud.com/dinglestein/horizons-change-perspectives",
    pubDate: "Thu, 18 Sep 2025 00:00:00 +0000",
    duration: "00:02:03",
    description:
      "From desert dunes to mountain snows\nEvery mile a story unfolds\n\nSaris swirl in markets bright\nTemples glow in sacred light",
    artwork:
      "https://i1.sndcdn.com/artworks-2rRLo6rujT1eTybB-S2sspA-t3000x3000.png",
  },
  {
    id: "2169779499",
    title: "The Endless Game",
    url: "https://soundcloud.com/dinglestein/the-endless-game",
    pubDate: "Fri, 12 Sep 2025 00:00:00 +0000",
    duration: "00:01:57",
    description:
      "Politics become the death games we replay\nEchoes of the past in every price we pay\n\nSpiraling the cycle till the crowd can’t look away\nWe’re all pieces moved in a merciless play",
    artwork:
      "https://i1.sndcdn.com/artworks-fIgfULHb3galV2A9-hNwBNw-t3000x3000.png",
  },
  {
    id: "2166118467",
    title: "Vancouver Breeze",
    url: "https://soundcloud.com/dinglestein/vancouver-breeze",
    pubDate: "Fri, 05 Sep 2025 00:00:00 +0000",
    duration: "00:01:59",
    description:
      "Oh, Vancouver breeze, carry me home\nWhere the ocean meets the pines I roam\n\nWild and free, in this coastal sea\nBC dreams awaken inside of me",
    artwork:
      "https://i1.sndcdn.com/artworks-3lGhzpcwj7WFFxw0-Mp9mJw-t3000x3000.png",
  },
  {
    id: "2165820039",
    title: "Merciless Midgets",
    url: "https://soundcloud.com/dinglestein/merciless-midgets",
    pubDate: "Fri, 05 Sep 2025 00:00:00 +0000",
    duration: "00:01:33",
    description:
      "Talls try to chase us, but they lag behind\nOur stomp hits the ground, ours is the grind\n\nMountains or mushrooms, we claim the lead\nGonna cross the line with lightning speed",
    artwork:
      "https://i1.sndcdn.com/artworks-Bs0WzGp6Q9PkpNhr-CnJJ5w-t3000x3000.png",
  },
  {
    id: "2165061129",
    title: "Movin' Again",
    url: "https://soundcloud.com/dinglestein/movin-again",
    pubDate: "Wed, 03 Sep 2025 00:00:00 +0000",
    duration: "00:01:57",
    description:
      "Boxes in the hallway, tape across the seams\nFour walls closing in on all my new dreams\n\nStackin' up the memories, sealing up the past\nHeartbeat to the rhythm, breakin' free at last",
    artwork:
      "https://i1.sndcdn.com/artworks-H2ITG3d8r1ONcEfD-Wqj5Lw-t3000x3000.png",
  },
  {
    id: "2164481550",
    title: "Emerald Haze",
    url: "https://soundcloud.com/dinglestein/emerald-haze",
    pubDate: "Wed, 03 Sep 2025 00:00:00 +0000",
    duration: "00:01:24",
    description:
      "High on hope, floating on the breeze\nNature’s remedy beneath the trees\n\nLet the green wave wash the day away\nIn this gentle space we choose to stay",
    artwork:
      "https://i1.sndcdn.com/artworks-HwLJWRoFEuNz2Dz7-qd15Rw-t3000x3000.png",
  },
  {
    id: "2164427142",
    title: "Bring Back the 90s",
    url: "https://soundcloud.com/dinglestein/bring-back-the-90s",
    pubDate: "Wed, 03 Sep 2025 00:00:00 +0000",
    duration: "00:02:34",
    description:
      "Skater kicks and flannel tees\nTamagotchi buzzin’ on my sleeve\n\nArcade lights in RGB\nWe ride the beat in MTV",
    artwork:
      "https://i1.sndcdn.com/artworks-GrO1DtyyuIBJjz2m-WtKyTw-t3000x3000.png",
  },
  {
    id: "2163923349",
    title: "Beyond the Ice Wall",
    url: "https://soundcloud.com/dinglestein/beyond-the-ice-wall",
    pubDate: "Tue, 02 Sep 2025 00:00:00 +0000",
    duration: "00:01:45",
    description:
      "Cracks in frozen kingdoms whisper tales untold\nCurrents stir below where mysteries unfold\n\nDiving past the chill into uncharted seas\nQuantum echoes call in ancient melodies",
    artwork:
      "https://i1.sndcdn.com/artworks-dyzOefqinoEftI12-RUbyyg-t3000x3000.png",
  },
  {
    id: "2163443688",
    title: "GOATMODE",
    url: "https://soundcloud.com/dinglestein/goatmode",
    pubDate: "Mon, 01 Sep 2025 00:00:00 +0000",
    duration: "00:01:19",
    description:
      "I’m the greatest, I’m the GOAT—watch me take flight\nNo more dwelling in the shadows, I’m the king of the night\n\nTest me if you want, I’ll be shining in the glow\nFrom the bottom to the top, now the whole world know",
    artwork:
      "https://i1.sndcdn.com/artworks-6GGr2RpBDZpzumBp-NV2vjA-t3000x3000.png",
  },
  {
    id: "2163278538",
    title: "Water Under the Bridge",
    url: "https://soundcloud.com/dinglestein/water-under-the-bridge",
    pubDate: "Mon, 01 Sep 2025 00:00:00 +0000",
    duration: "00:02:58",
    description:
      "When one door closes, another opens wide\nLife’s a river bending, shifting with the tide\n\nGrow into the moment, evolution’s song\nOvercome the defect, keep moving on",
    artwork:
      "https://i1.sndcdn.com/artworks-mJQao0QiKDPntaGL-8ec8AA-t3000x3000.png",
  },
  {
    id: "2162698566",
    title: "Red Thread of Love",
    url: "https://soundcloud.com/dinglestein/red-thread-of-love",
    pubDate: "Sun, 31 Aug 2025 00:00:00 +0000",
    duration: "00:02:26",
    description:
      "Bound by the red thread of love\nCrossing oceans and skies above\n\nDestined soulmates side by side\nOur rose of life, our hearts collide",
    artwork:
      "https://i1.sndcdn.com/artworks-jMQL5eBhtnxR7Ua5-WVAUGQ-t3000x3000.png",
  },
  {
    id: "2162574930",
    title: "BURGER NATION",
    url: "https://soundcloud.com/dinglestein/burger-nation",
    pubDate: "Sat, 30 Aug 2025 00:00:00 +0000",
    duration: "00:01:33",
    description:
      "Burger nation, nom nom all day\nPatty on a sesame crown, we never stray\n\nDash burger be gone, slide down the throat\nKeep America tasty, that’s the code we promote",
    artwork:
      "https://i1.sndcdn.com/artworks-OjJQfBtI7BXU8BGi-uKbZOg-t3000x3000.jpg",
  },
  {
    id: "2162302383",
    title: "Darkside of the Moon",
    url: "https://soundcloud.com/dinglestein/darkside-of-the-moon",
    pubDate: "Sat, 30 Aug 2025 00:00:00 +0000",
    duration: "00:02:19",
    description:
      "Colors paint the sky when your heartbeat speaks\nIn this crowded room, our spirits meet\n\nUnder lantern light we sway and shine\nEvery moment here becomes divine",
    artwork:
      "https://i1.sndcdn.com/artworks-zGLywQs3mqynfqeU-rq3EWA-t3000x3000.png",
  },
  {
    id: "2162233662",
    title: "Lightside of the Moon",
    url: "https://soundcloud.com/dinglestein/lightside-of-the-moon",
    pubDate: "Fri, 29 Aug 2025 00:00:00 +0000",
    duration: "00:01:37",
    description:
      "Let the rhythm take you higher\nElectric waves of our desire\n\nSitar sings above the night\nWe are wild in the city lights",
    artwork:
      "https://i1.sndcdn.com/artworks-thSQXlb9wzte7uNg-15Dxjg-t3000x3000.png",
  },
  {
    id: "2161901049",
    title: "Vibrations",
    url: "https://soundcloud.com/dinglestein/vibrations",
    pubDate: "Fri, 29 Aug 2025 00:00:00 +0000",
    duration: "00:01:48",
    description:
      "Rise up, seeker of the fading light\nLet ancient drums guide you through the night\n\nYour heart a beacon, your spirit free\nDance these vibrations, set your courage free",
    artwork:
      "https://i1.sndcdn.com/artworks-rtcVwcf1qyzXcFaQ-Ev5jtw-t3000x3000.png",
  },
  {
    id: "2161372665",
    title: "Sentient Savage",
    url: "https://soundcloud.com/dinglestein/sentient-savage",
    pubDate: "Fri, 29 Aug 2025 00:00:00 +0000",
    duration: "00:01:15",
    description: "Sentient Savage by dinglestein",
    artwork:
      "https://i1.sndcdn.com/artworks-Y9tLUirFIU7Q72dR-FndZyA-t3000x3000.png",
  },
  {
    id: "2161250097",
    title: "BE WATER",
    url: "https://soundcloud.com/dinglestein/be-water",
    pubDate: "Thu, 28 Aug 2025 00:00:00 +0000",
    duration: "00:01:22",
    description:
      "Like river bends tracing ancient lines,\nWe find our course through space and time,\n\nCrystal currents wash away the past,\nAnd guide us gently to the vast.",
    artwork:
      "https://i1.sndcdn.com/artworks-v5GjquMdNAh4Lpqo-mQ9TJA-t3000x3000.jpg",
  },
  {
    id: "2160617889",
    title: "Blooming Rose",
    url: "https://soundcloud.com/dinglestein/blooming-rose",
    pubDate: "Thu, 28 Aug 2025 00:00:00 +0000",
    duration: "00:01:41",
    description:
      "I found you in the midnight glow,\nA secret garden no one knows\n\nPetals dancing in the neon lights,\nYour beauty blooming in the night",
    artwork:
      "https://i1.sndcdn.com/artworks-0P5K9xoxzNTxUZBn-8UYp2w-t3000x3000.png",
  },
  {
    id: "2161006911",
    title: "Dharma Gates",
    url: "https://soundcloud.com/dinglestein/dharma-gates",
    pubDate: "Wed, 27 Aug 2025 00:00:00 +0000",
    duration: "00:01:34",
    description:
      "Stacks of paper held the throne, now data carves the mold\nPalm to palm, the power grown, in algorithms told\n\nFollow feeds that shape your creed, every click’s a clue\nMind the gate inside your head, let wisdom guide you through",
    artwork:
      "https://i1.sndcdn.com/artworks-KgI4oq80FiJyvWy3-mC6uHw-t3000x3000.jpg",
  },
  {
    id: "2160342201",
    title: "Midnight Block Run",
    url: "https://soundcloud.com/dinglestein/midnight-block-run",
    pubDate: "Wed, 27 Aug 2025 00:00:00 +0000",
    duration: "00:01:27",
    description:
      "Riding down the block, we don’t mind the clock\nCrew’s gathering slow where the neon lights talk\n\nHolding down the corner where the night gently rocks\nJazzy in our veins, while the rooftop talks",
    artwork:
      "https://i1.sndcdn.com/artworks-6ofvqyrzgWBjWTyp-aFunKA-t3000x3000.png",
  },
  {
    id: "2159959737",
    title: "Sounds of the Forest",
    url: "https://soundcloud.com/dinglestein/sounds-of-the-forest",
    pubDate: "Tue, 26 Aug 2025 00:00:00 +0000",
    duration: "00:01:36",
    description: "Feel the heartbeat of the trees\nCalling you to wild seas",
    artwork:
      "https://i1.sndcdn.com/artworks-SGlw3VoJ5RagSWGK-yNab4w-t3000x3000.png",
  },
  {
    id: "2159534094",
    title: "COMBAT",
    url: "https://soundcloud.com/dinglestein/combat",
    pubDate: "Mon, 25 Aug 2025 00:00:00 +0000",
    duration: "00:01:53",
    description:
      "We fight for pole position, on this wavy ride\nIn future bass ignition, legends come alive\n\nFrom Senna to Hamilton, echoes in our veins\nWe chase the checkered flag, adrenaline remains",
    artwork:
      "https://i1.sndcdn.com/artworks-deeUbPROEOznWMBy-Y7gSlg-t3000x3000.png",
  },
  {
    id: "2159399088",
    title: "Children of Tomorrow",
    url: "https://soundcloud.com/dinglestein/children-of-tomorrow",
    pubDate: "Mon, 25 Aug 2025 00:00:00 +0000",
    duration: "00:01:51",
    description:
      "Children of tomorrow, we carry your name\nCasting off the darkness, tearing down the chains\n\nGod gave us freedom, let compassion remain\nTogether we stand, never fall in vain",
    artwork:
      "https://i1.sndcdn.com/artworks-sYBWC7WCMHh0tSKJ-jxN2WA-t3000x3000.png",
  },
  {
    id: "2158620639",
    title: "Rise of the Machine (Time Warp Phonk)",
    url: "https://soundcloud.com/dinglestein/rise-of-the-machine-time-warp-phonk",
    pubDate: "Sat, 23 Aug 2025 00:00:00 +0000",
    duration: "00:01:35",
    description:
      "John Connor’s time machine, take me back when it was clean\nBefore the bots took over every fuckin’ dream\n\nRise of the machine, break the code, flip the scene\nFilthy party phonk—wreck the system on the beat",
    artwork:
      "https://i1.sndcdn.com/artworks-GEBqoyKfqY2yqtsT-E4ySpw-t3000x3000.png",
  },
  {
    id: "2158560489",
    title: "CHAINED",
    url: "https://soundcloud.com/dinglestein/chained",
    pubDate: "Sat, 23 Aug 2025 00:00:00 +0000",
    duration: "00:01:51",
    description:
      "We’re more than numbers, more than ledger lies\nFeel the heartbeat under all those corporate ties",
    artwork:
      "https://i1.sndcdn.com/artworks-YxEVfqprE5Rw18Tb-BWVgwQ-t3000x3000.png",
  },
  {
    id: "2158260981",
    title: "Summer Sax",
    url: "https://soundcloud.com/dinglestein/summer-sax",
    pubDate: "Fri, 22 Aug 2025 00:00:00 +0000",
    duration: "00:01:41",
    description:
      "Recharged by the sun, feel the light on my skin\nSalt in the air, let the day begin\n\nFollow the blue, chase the mirage of dreams\nSummer in my veins, life’s more than it seems",
    artwork:
      "https://i1.sndcdn.com/artworks-kzRUgv4HwBceBndZ-yQxbhg-t3000x3000.png",
  },
  {
    id: "2158038603",
    title: "CONS-TELL-A-TON",
    url: "https://soundcloud.com/dinglestein/cons-tell-a-ton",
    pubDate: "Fri, 22 Aug 2025 00:00:00 +0000",
    duration: "00:02:34",
    description:
      "Lift me higher, let the cosmos speak\nPainted midnight guiding when I’m weak",
    artwork:
      "https://i1.sndcdn.com/artworks-OgA7t5QbWiS5Y8Xe-dp6YXg-t3000x3000.png",
  },
  {
    id: "2157837384",
    title: "Cosmic Grove",
    url: "https://soundcloud.com/dinglestein/cosmic-grove",
    pubDate: "Thu, 21 Aug 2025 00:00:00 +0000",
    duration: "00:01:53",
    description: "Galaxies align with each note\nOrbit swirling as we float",
    artwork:
      "https://i1.sndcdn.com/artworks-VbqPZWzAbNaqv5Oq-oGyFGQ-t3000x3000.png",
  },
  {
    id: "2157830523",
    title: "Rats of the Night",
    url: "https://soundcloud.com/dinglestein/rats-of-the-night",
    pubDate: "Thu, 21 Aug 2025 00:00:00 +0000",
    duration: "00:02:00",
    description:
      "In the savage fight, I ignite the light\nRats of the night, vanish from my life",
    artwork:
      "https://i1.sndcdn.com/artworks-JmVnPqYOnE68eeC1-jsASRw-t3000x3000.png",
  },
  {
    id: "2156789541",
    title: "King Dave",
    url: "https://soundcloud.com/dinglestein/king-dave",
    pubDate: "Thu, 21 Aug 2025 00:00:00 +0000",
    duration: "00:01:47",
    description:
      "Big ol’ doinks in Amish, smokin’ through the storm\nKing Dave, toot lord rising, feel the barn doors slam\n\nGang of 420 riders, blaze the rebel form\nBreaker of doinks, Amish, bow before the man",
    artwork:
      "https://i1.sndcdn.com/artworks-HiPBKeDHp9949sYO-hbPcUg-t3000x3000.png",
  },
  {
    id: "2157375624",
    title: "Drift",
    url: "https://soundcloud.com/dinglestein/drift",
    pubDate: "Wed, 20 Aug 2025 00:00:00 +0000",
    duration: "00:02:06",
    description:
      "Shatter through the darkness\nVibrations paint the sky\n\nRacing at the speed of light\nWhere shadows cannot hide",
    artwork:
      "https://i1.sndcdn.com/artworks-4z9fUqjfhlx7yK5t-DQ5d3w-t3000x3000.png",
  },
  {
    id: "2157248709",
    title: "Acoustic Lightspeed",
    url: "https://soundcloud.com/dinglestein/acoustic-lightspeed",
    pubDate: "Wed, 20 Aug 2025 00:00:00 +0000",
    duration: "00:01:01",
    description:
      "Speed of light, we come alive\nVibrations hum, we amplify\n\nPure energy in every byte\nFuture bass ignites the night",
    artwork:
      "https://i1.sndcdn.com/artworks-S4myGyaKy3HZuuqy-zUSdZg-t3000x3000.png",
  },
  {
    id: "2157154419",
    title: "Bears Beets Battlestar Galactica",
    url: "https://soundcloud.com/dinglestein/bears-beets-battlestar-galactica",
    pubDate: "Wed, 20 Aug 2025 00:00:00 +0000",
    duration: "00:01:07",
    description:
      "Bears, beets, Battlestar Galactica\nLoop it in my mind like a vinyl mantra\n\nForest to the cosmos, journey's automatic-a\nBears, beets, Battlestar Galactica",
    artwork:
      "https://i1.sndcdn.com/artworks-B2X5otWXn9wyFjMa-tSh0CA-t3000x3000.png",
  },
  {
    id: "2156438079",
    title: "Shadowstep Symphony",
    url: "https://soundcloud.com/dinglestein/shadowstep-symphony",
    pubDate: "Wed, 20 Aug 2025 00:00:00 +0000",
    duration: "00:01:50",
    description:
      "Heartbeat racing as the cooldown ends\nI strike from shadows where the story bends",
    artwork:
      "https://i1.sndcdn.com/artworks-HzB5HqUDFjedmrp0-LUfIVA-t3000x3000.png",
  },
  {
    id: "2156289687",
    title: "Duff the Dirty Dutchman",
    url: "https://soundcloud.com/dinglestein/duff-the-dirty-dutchman",
    pubDate: "Wed, 20 Aug 2025 00:00:00 +0000",
    duration: "00:01:04",
    description: "Duff Man’s got that Dutch spice\nOh yeah, feel it rise!",
    artwork:
      "https://i1.sndcdn.com/artworks-iTM8iBN6hYKyNySX-JbuniQ-t3000x3000.png",
  },
  {
    id: "2156670888",
    title: "Floral Foundations",
    url: "https://soundcloud.com/dinglestein/floral-foundations",
    pubDate: "Tue, 19 Aug 2025 00:00:00 +0000",
    duration: "00:02:09",
    description:
      "In May’s green dawn the lily wakes\n\nWhen summer calls, the roses bloom",
    artwork:
      "https://i1.sndcdn.com/artworks-9Ff5wvVWBT86M9o3-sJPxMA-t3000x3000.png",
  },
  {
    id: "2156583141",
    title: "Runes of Valhalla",
    url: "https://soundcloud.com/dinglestein/runes-of-valhalla",
    pubDate: "Tue, 19 Aug 2025 00:00:00 +0000",
    duration: "00:02:08",
    description:
      "Rise, rise, techno Vikings rising!\nChant the gods in thunder’s echo\n\nFly, fly, on wings of raven’s flight\nWe ride the storm together, onward!",
    artwork:
      "https://i1.sndcdn.com/artworks-QqckrK6uuKGezb3M-oYH3tg-t3000x3000.png",
  },
  {
    id: "2156249130",
    title: "Night Bus",
    url: "https://soundcloud.com/dinglestein/night-bus",
    pubDate: "Tue, 19 Aug 2025 00:00:00 +0000",
    duration: "00:01:15",
    description:
      "Lights flicker on the window pane, fam\nNeon ghosts say ‘blud’, know the name\n\nCity hum beneath my creps\nNight bus rollin’, no stress",
    artwork:
      "https://i1.sndcdn.com/artworks-A6CIfXNc9fbtyPZV-2tzJtA-t3000x3000.png",
  },
  {
    id: "2156247012",
    title: "Marauders Map",
    url: "https://soundcloud.com/dinglestein/marauders-map",
    pubDate: "Tue, 19 Aug 2025 00:00:00 +0000",
    duration: "00:01:49",
    description:
      "Run with me through Hogsmeade lanes\nTwilight magic running in our veins\n\nWe’re unseen, but we’ll make our mark\nMarauder’s Map leading through the dark",
    artwork:
      "https://i1.sndcdn.com/artworks-s5MpaU7CKjhAf0Jz-yK9v7g-t3000x3000.png",
  },
  {
    id: "2156180025",
    title: "Tribe Up",
    url: "https://soundcloud.com/dinglestein/tribe-up",
    pubDate: "Tue, 19 Aug 2025 00:00:00 +0000",
    duration: "00:02:01",
    description:
      "Ooh-ahh, ooh-ahh, we gather as one\nFeel the thunder beating from our drums\n\nNo force can break us, we stand strong\nTogether we rise, united in song",
    artwork:
      "https://i1.sndcdn.com/artworks-Xa7vwFCfzQ3QPAU1-KP4kqg-t3000x3000.png",
  },
  {
    id: "2156033124",
    title: "Timbits Box",
    url: "https://soundcloud.com/dinglestein/timbits-box",
    pubDate: "Mon, 18 Aug 2025 00:00:00 +0000",
    duration: "00:01:17",
    description: "Hey, Pass me that Timbits box!\n\nYo, Don’t drop that donut!",
    artwork:
      "https://i1.sndcdn.com/artworks-kWR3yWKwyMCzV4FJ-a3306w-t3000x3000.png",
  },
  {
    id: "2155694601",
    title: "Night Owl",
    url: "https://soundcloud.com/dinglestein/night-owl",
    pubDate: "Mon, 18 Aug 2025 00:00:00 +0000",
    duration: "00:01:36",
    description: "After midnight, gravity’s loose\nStarlit highway, no excuse",
    artwork:
      "https://i1.sndcdn.com/artworks-NUZ91LEndoz5XMpk-7euKZA-t3000x3000.png",
  },
  {
    id: "2155341504",
    title: "Legends of Enoch",
    url: "https://soundcloud.com/dinglestein/legends-of-enoch",
    pubDate: "Mon, 18 Aug 2025 00:00:00 +0000",
    duration: "00:01:24",
    description:
      "Open the Book of Enoch, secrets veiled in black\nDragons writhe in smoke, no turning back\n\nGriffons claw the sky in a blood-red haze\nUnicorns bleed light through these haunted mazes",
    artwork:
      "https://i1.sndcdn.com/artworks-jg1FGPk8XramPFXO-l5Yf2w-t3000x3000.png",
  },
  {
    id: "2154887412",
    title: "Surrey to Compton",
    url: "https://soundcloud.com/dinglestein/surrey-to-compton",
    pubDate: "Mon, 18 Aug 2025 00:00:00 +0000",
    duration: "00:01:24",
    description: "Surrey to Compton by dinglestein",
    artwork:
      "https://i1.sndcdn.com/artworks-AsjiWveg1sqTtaCE-r92QCw-t3000x3000.png",
  },
  {
    id: "2155533642",
    title: "The Great Reset",
    url: "https://soundcloud.com/dinglestein/the-great-reset",
    pubDate: "Sun, 17 Aug 2025 00:00:00 +0000",
    duration: "00:02:15",
    description:
      "Solum aeternum, tenebrae vocant\nAqua fluctus magnae resonant\n\nUmbrae cadunt, mundus tremit\nInitium novum, Terra transit",
    artwork:
      "https://i1.sndcdn.com/artworks-Lz65S5LjomUj6ij3-QE96Ag-t3000x3000.png",
  },
  {
    id: "2154819420",
    title: "Stranger Tings",
    url: "https://soundcloud.com/dinglestein/stranger-tings",
    pubDate: "Sun, 17 Aug 2025 00:00:00 +0000",
    duration: "00:01:52",
    description:
      "Montauk project rising from the deep\nWhere the past and present start to bleed\n\nEchoes of the future in the static stream\nMontauk holds the key to every dream",
    artwork:
      "https://i1.sndcdn.com/artworks-CUdzVzm35InIXsXY-8htutw-t3000x3000.png",
  },
  {
    id: "2154433284",
    title: "Poutine Dreams",
    url: "https://soundcloud.com/dinglestein/poutine-dreams",
    pubDate: "Sun, 17 Aug 2025 00:00:00 +0000",
    duration: "00:01:25",
    description:
      "Late night on the porch, maple breeze in the air\nGolden fries dippin’ in gravy, man, that’s Canadian flair\n\nRed and white flag wavin’, unity in every bite\nCheese curds meltin’ gently, heritage feels so right\n\nOrigin in Québec kitchens, humble towns built the dream\nNow it’s coast to coast lovin’, from Vancouver to the stream",
    artwork:
      "https://i1.sndcdn.com/artworks-8u1gIHs7k53zIDVG-mbOAzw-t3000x3000.png",
  },
  {
    id: "2154906207",
    title: "Rat Lines",
    url: "https://soundcloud.com/dinglestein/rat-lines",
    pubDate: "Sat, 16 Aug 2025 00:00:00 +0000",
    duration: "00:01:19",
    description:
      "Ratlines to the south—hear the bass crash the ground\nShadows on the run—no surrender, no sound\n\nHistory in reverse—see the stories untold\nDark secrets reborn—heavy lies the gold",
    artwork:
      "https://i1.sndcdn.com/artworks-on6TBOTdV68gynsr-nImB9Q-t3000x3000.png",
  },
  {
    id: "2154858588",
    title: "Light VS Dark",
    url: "https://soundcloud.com/dinglestein/light-vs-dark",
    pubDate: "Sat, 16 Aug 2025 00:00:00 +0000",
    duration: "00:02:01",
    description:
      "Music Video:\nhttps://www.youtube.com/watch?v=vr7Bj1vPDME&amp;ab_channel=dinglesteinmusic\n\nTogether we shine bright, we’re the dawn after night\nBreaking through shadowed skies, bringing warmth with our light\n\nWinter’s cold can’t hide the fire burning in our eyes\nHand in hand we rise, glowing ever high",
    artwork:
      "https://i1.sndcdn.com/artworks-PRHGxDsMIxAzqQXA-MK45qg-t3000x3000.png",
  },
  {
    id: "2154463026",
    title: "Ganja Rise",
    url: "https://soundcloud.com/dinglestein/ganja-rise",
    pubDate: "Sat, 16 Aug 2025 00:00:00 +0000",
    duration: "00:02:01",
    description:
      "Ganja rise, ganja shine\nOpen up your heart and mind\n\nGanja rise, ganja shine\nMind and soul align",
    artwork:
      "https://i1.sndcdn.com/artworks-kQvaWPES2QXudKLH-r40TcQ-t3000x3000.png",
  },
  {
    id: "2154370392",
    title: "Sun &amp; Saddle",
    url: "https://soundcloud.com/dinglestein/sun-and-saddle",
    pubDate: "Sat, 16 Aug 2025 00:00:00 +0000",
    duration: "00:01:32",
    description:
      "Music Video:\nhttps://www.youtube.com/watch?v=zo7xVGnWnv4&amp;ab_channel=dinglesteinmusic\n\nUnder the sun and saddles we fly\nFree as the wind with you by my side\n\nBeachside barrel race, hearts in a chase\nSummer flames rising in your warm embrace",
    artwork:
      "https://i1.sndcdn.com/artworks-juKnNGeSayFCPUz3-9a3mjA-t3000x3000.png",
  },
  {
    id: "2154162693",
    title: "GLITCH",
    url: "https://soundcloud.com/dinglestein/glitch",
    pubDate: "Sat, 16 Aug 2025 00:00:00 +0000",
    duration: "00:01:55",
    description:
      "Music Video:\nhttps://www.youtube.com/watch?v=bk4XJVzdLEU&amp;ab_channel=dinglesteinmusic\n\nIn a world where code and steel collide…\n\nWe’re infinite loops in the space-time core,\nMatrix code in the Terminator war.",
    artwork:
      "https://i1.sndcdn.com/artworks-1b2yJQq4HxGTPZQO-TcgQyQ-t3000x3000.png",
  },
  {
    id: "2154107124",
    title: "Step in the Zone",
    url: "https://soundcloud.com/dinglestein/step-in-the-zone",
    pubDate: "Sat, 16 Aug 2025 00:00:00 +0000",
    duration: "00:02:27",
    description:
      "Music Video:\nhttps://www.youtube.com/watch?v=tzlZmGgRTnc&amp;ab_channel=dinglesteinmusic\n\nStep in the zone, heart starts to rise\nPulse of the night, neon in our eyes\n\nChasing the spark when the world goes dark\nMind on the mission, light up the dark",
    artwork:
      "https://i1.sndcdn.com/artworks-oGvbKF8ztRDRK45w-M6nUXA-t3000x3000.png",
  },
  {
    id: "2154101748",
    title: "Level Up",
    url: "https://soundcloud.com/dinglestein/level-up",
    pubDate: "Sat, 16 Aug 2025 00:00:00 +0000",
    duration: "00:02:14",
    description:
      "Music Video:\nhttps://www.youtube.com/watch?v=rD0vUDb_jdg&amp;ab_channel=dinglesteinmusic\n\nLevel up, no turning back\n\nAll in, attack, impact\nRide the wave, adrenaline blast",
    artwork:
      "https://i1.sndcdn.com/artworks-3uDpb1kZ6WyZitJa-3yYgfQ-t3000x3000.png",
  },
  {
    id: "2154037500",
    title: "Raincouver Mist",
    url: "https://soundcloud.com/dinglestein/raincouver-mist",
    pubDate: "Sat, 16 Aug 2025 00:00:00 +0000",
    duration: "00:03:24",
    description:
      "Let the future tell the truth and evaluate each one according to his work and accomplishments. The present is theirs; the future, for which I have really worked, is mine. —Nikola Tesla",
    artwork:
      "https://i1.sndcdn.com/artworks-fvmmmyRTt8lu1hy3-Uayo8g-t3000x3000.png",
  },
  {
    id: "2154029562",
    title: "Gemini Generations",
    url: "https://soundcloud.com/dinglestein/gemini-generations",
    pubDate: "Sat, 16 Aug 2025 00:00:00 +0000",
    duration: "00:01:14",
    description: "Gemini Generations by dinglestein",
    artwork:
      "https://i1.sndcdn.com/artworks-5HGpvtgkK4fJfF6F-EmT0QQ-t3000x3000.png",
  },
  {
    id: "2154757680",
    title: "Light the Stormy Weather",
    url: "https://soundcloud.com/dinglestein/light-the-stormy-weather",
    pubDate: "Fri, 15 Aug 2025 00:00:00 +0000",
    duration: "00:01:48",
    description:
      "When we join our sparks together\nWe can light the stormy weather",
    artwork:
      "https://i1.sndcdn.com/artworks-PVJ6EXRzIhHLFl12-fnpIeQ-t3000x3000.png",
  },
  {
    id: "2153982219",
    title: "Era of Light",
    url: "https://soundcloud.com/dinglestein/era-of-light",
    pubDate: "Fri, 15 Aug 2025 00:00:00 +0000",
    duration: "00:02:16",
    description:
      "Music Video:\nhttps://www.youtube.com/watch?v=DMDDZSrK6wY&amp;ab_channel=dinglesteinmusic\n\nHigher and higher, we leave fear behind\nLove's the language that unites all humankind",
    artwork:
      "https://i1.sndcdn.com/artworks-LLPtSGJP5B4ugNhf-2i2Epg-t3000x3000.png",
  },
  {
    id: "2153966256",
    title: "Smoke &amp; Mirrors",
    url: "https://soundcloud.com/dinglestein/smoke-and-mirrors",
    pubDate: "Wed, 13 Aug 2025 00:00:00 +0000",
    duration: "00:01:19",
    description:
      "Music Video:\nhttps://www.youtube.com/watch?v=6eZ8x8TVnrI&amp;ab_channel=dinglesteinmusic\n\nSmoke and mirrors with all our fears\nEyes in the sky, choking off our cheers\n\nThey own the ends, they own the means\nLivin’ life inside their machines",
    artwork:
      "https://i1.sndcdn.com/artworks-hoTfz78yG0WR5lAo-ypWnmg-t3000x3000.jpg",
  },
  {
    id: "2153623374",
    title: "Echoes of Tartaria",
    url: "https://soundcloud.com/dinglestein/echoes-of-tartaria",
    pubDate: "Wed, 13 Aug 2025 00:00:00 +0000",
    duration: "00:01:44",
    description:
      "Music Video:\nhttps://www.youtube.com/watch?v=-pXU2FglpFI&amp;ab_channel=dinglesteinmusic\n\nDusty scrolls and neon signs\nCosmic clocks in shifting minds\n\nPharaohs’ dreams in desert lines\nCelestial codes in burning signs\n\nWe chase the beat across the dunes\nHolding secrets in these tunes",
    artwork:
      "https://i1.sndcdn.com/artworks-9dBwW1JdJai70HzM-TpoWTg-t3000x3000.png",
  },
  {
    id: "2153546298",
    title: "Mind Over Clock",
    url: "https://soundcloud.com/dinglestein/mind-over-clockmind-over-clock",
    pubDate: "Tue, 12 Aug 2025 00:00:00 +0000",
    duration: "00:01:27",
    description:
      "Music Video:\nhttps://www.youtube.com/watch?v=d-B7saIo8Fk&amp;ab_channel=dinglesteinmusic\n\nMind over clock, new paths we authorize\nRise up, visualize, revolutionize",
    artwork:
      "https://i1.sndcdn.com/artworks-GxKNUmh9PAyXbEbZ-dF3yWA-t3000x3000.png",
  },
  {
    id: "2153519172",
    title: "Sunny Days",
    url: "https://soundcloud.com/dinglestein/sunny-days",
    pubDate: "Tue, 12 Aug 2025 00:00:00 +0000",
    duration: "00:02:01",
    description:
      "Music Video:\nhttps://www.youtube.com/watch?v=lH8Ru-JRPRA&amp;ab_channel=dinglesteinmusic\n\nWe are electro-magnetic beings, let mother nature heal and recharge your energy.\n\nPicture mornings where golden light spills through your windows like honey, warming the air with that particular brightness that makes everything feel possible. The kind of days where shadows are crisp and defined, where colors seem more saturated - the deep blue of the sky, the vibrant green of leaves catching sunlight, the warm terracotta of brick buildings glowing in the afternoon warmth.",
    artwork:
      "https://i1.sndcdn.com/artworks-PfOGzGiVELEPyeXo-JzCKOw-t3000x3000.jpg",
  },
  {
    id: "2153525307",
    title: "The Aquarian Age",
    url: "https://soundcloud.com/dinglestein/the-aquarian-age",
    pubDate: "Mon, 11 Aug 2025 00:00:00 +0000",
    duration: "00:01:51",
    description:
      "Music Video:\nyoutube.com/watch?v=32D3Ho6at3c&amp;feature=youtu.be\n\nThe Aquarian Age, in astrology and spiritual contexts, signifies a shift from the previous Age of Pisces, characterized by hierarchy and control, towards an era of increased interconnectedness, humanitarianism, and technological advancement. It's associated with concepts like freedom, equality, and social justice, and a collective quest for truth and authenticity.",
    artwork:
      "https://i1.sndcdn.com/artworks-rrpLdUsGPHFMBvXY-MHYiIA-t3000x3000.png",
  },
];

export const lastSynced: string = "2026-10-01T23:45:17.660Z";
